const loading = {
  data () {
    return {
      isLoading: 0
    }
  }
}
export default loading
